import {
  Breadcrumbs,
  Inline,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useNavigate } from 'react-router';

import {
  InvoiceReportList,
  InvoiceReportPayActions,
} from '../../../features/invoice-reports';

export const INVOICE_REPORTS_LIST_PAGE_TITLE = 'Invoices';

const INVOICE_REPORTS_PAGE_TITLE = 'Invoices';

export const InvoiceReports = () => {
  const navigate = useNavigate();

  return (
    <>
      <Stack gap="16">
        <Breadcrumbs
          crumbs={[
            { id: 'home', title: 'Home', onClick: () => navigate('/') },
            {
              id: 'invoices',
              title: INVOICE_REPORTS_LIST_PAGE_TITLE,
              active: true,
            },
          ]}
        />
        <Inline
          minH={40}
          align="center"
          justify={'space-between'}
          css={{ flexWrap: 'wrap' }}
        >
          <Typography as="h3" hideParagraphSpacing size="24" weight="medium">
            {INVOICE_REPORTS_PAGE_TITLE}
          </Typography>
          <InvoiceReportPayActions />
        </Inline>
      </Stack>

      <InvoiceReportList />
    </>
  );
};
